<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template  000080  004379
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent, Martin vicencio benko hanck
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img" id="page-login">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <!-- style="background: #004379;" le agregue el color azul perron debajo dela imagen png de upb -->
                    <div class="vx-row " style="background: #004379;"> 
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center" >
                            <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="p-8" style="margin:25px;">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Acceder</h4>
                                    <p>Bienvenido, capture sus datos de acceso:</p>
                                </div>
                              <form v-on:submit.prevent="login">
                                <vs-input
                                    v-validate="'required|min:3'"
                                    data-vv-validate-on="blur"
                                    name="usuario"
                                    icon="icon icon-user"
                                    icon-pack="feather"
                                    label-placeholder="Usuario (Matricula)"
                                    v-model="email"
                                    class="w-full no-icon-border"/>
                                <span class="text-danger text-sm">{{ errors.first('usuario') }}</span>

                                <vs-input
                                    data-vv-validate-on="blur"
                                    v-validate="'required|min:8|max:50'"
                                    type="password"
                                    name="contraseña"
                                    icon="icon icon-lock"
                                    icon-pack="feather"
                                    label-placeholder="Contraseña"
                                    v-model="password"
                                    class="w-full mt-6 no-icon-border" />
                                <span class="text-danger text-sm">{{ errors.first('contraseña') }}</span>

                                <div class="flex flex-wrap justify-between my-5">
                                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Recordarme</vs-checkbox>
                                    <router-link to="/pages/forgot-password">¿Olvido su contraseña?</router-link>
                                </div>
                                <vs-button class="float-right" :disabled="!validateForm" @click="login">Entrar</vs-button>
                              </form>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            email: '',
            password: '',
            checkbox_remember_me: false
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any() && this.email != '' && this.password != '';
        },
    },
    created() {
        localStorage.clear();
    },
    methods: {

        login(e) {
          e.preventDefault()
        this.$http.post('login', {
                    user: this.email,
                    password: this.password
                })
            .then(response => {
                if (response.data.message) {
                  this.$vs.notify({
                      time: 2500,
                      title: 'Error',
                      text: response.data.message,
                      iconPack: 'feather',
                      icon: 'icon-alert-circle',
                      color: 'danger'
                  });
                } else {
                  localStorage.setItem('app-token', response.data.token); //en setitem es para colocar o setear la respuesta del api y/0 data en app-token 
                  let id_rol = this.getKey('id_rol');  //obtenemos datos del token de lso cual sabemos que estan en la cadena y lo seteamos en una variable 
                  if(id_rol == '1'){ //admin
                      localStorage.setItem('id', this.getKey('id'))
                    localStorage.setItem('id_carrera', this.getKey('id_carrera'))
                    this.$router.push('/administrativos/alumnos');
                  }
                  if(id_rol == '2'){  //directores
                      localStorage.setItem('id', this.getKey('id'))
                      localStorage.setItem('id_carrera', this.getKey('id_carrera'))
                    this.$router.push('/directores/datos_user');
                  }
                  if(id_rol == '3'){  // profesores
                      localStorage.setItem('id', this.getKey('id'))
                    // this.$router.push('/profesores/grupos');
                     this.$router.push('/profesores/datos_user');
                  }
                  if(id_rol == '4'){  // alumnos
                      localStorage.setItem('id', this.getKey('id'))
                      localStorage.setItem('matricula', this.getKey('matricula'))
                      localStorage.setItem('id_carrera', this.getKey('id_carrera'))
                      localStorage.setItem('status_alumno', this.getKey('status_alumno'))
                    //   console.log('status',this.getKey('status_alumno'));
                      //this.$router.push('/alumnos/calificaciones') //pastor lo tenia en calificaciones
                    this.$router.push('/alumnos/datos');
                    // this.$router.push('/alumnos/inscripcion');
                  }
                    if(id_rol == '5'){
                    //menu para controle scolar
                        // localStorage.setItem('id', this.getKey('id'))
                        // localStorage.setItem('id_alumno', this.getKey('cuenta'))
                        // this.$router.push('/aspirantes/cargar_documentos')
                    localStorage.setItem('id', this.getKey('id'))
                    localStorage.setItem('id_carrera', this.getKey('id_carrera'))
                    this.$router.push('/administrativos/alumnos');
                    }
                    if(id_rol == '6'){ //idiomas
                        localStorage.setItem('id', this.getKey('id'))
                        localStorage.setItem('id_carrera', this.getKey('id_carrera'))
                        // this.$router.push('/administrativos/alumnos');
                           this.$router.push('/idiomas/datos_user');
                        
                    }
                    if(id_rol == '7'){ //vinculacion
                        localStorage.setItem('id', this.getKey('id'))
                        localStorage.setItem('id_carrera', this.getKey('id_carrera'))
                        // this.$router.push('/administrativos/alumnos');
                           this.$router.push('/vinculacion/datos_user');
                        
                    }
                }
              }
              )
      },

    }
}
</script>

